import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import AlertDialog from '../../components/Dialog/alertDialog';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  INewsAndAnnouncementStore,
} from '../../mobx-store/storeInterfaces/newsAndAnnouncementInterface';
import {
  INewsCategoryStore,
} from '../../mobx-store/storeInterfaces/newsCategoryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditArticle.module.scss';
import { images } from 'assets/image';
import moment from 'moment';
import {
  convertToRaw,
} from 'draft-js';
import parse from 'html-react-parser';
import draftToHtml from "draftjs-to-html";

interface IProps extends WithSnackbarProps {
  newsAndAnnouncementStore: INewsAndAnnouncementStore;
  newsCategoryStore: INewsCategoryStore;
  countryStore: CountryStore;
  match: any;
  history: any;
  type: 'news' | 'announcement';
}

interface IState {
  formFields: FormField[];
  categories: any[];
  loadingArticle: boolean;
  loadingCategories: boolean;
  loadingManagedCountries: boolean;
  processing: boolean;
  selectedLang: string;
  open: boolean;
  title: string;
  articleCategory: string;
  description: any;
  image: string;
  startDate: number | null;
  images: any[];
  video: any[];
}

@inject('newsAndAnnouncementStore')
@inject('countryStore')
@inject('newsCategoryStore')
@observer
class AddEditArticle extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  articleId = -1;

  pageTitle = '';

  lastHistory = -1;

  articleFormTitle = '';

  articleSchema: any;

  submitButton: any;

  cancelButton: any;

  initGallery: { imageUrl: string; key: number }[] = [];

  dropdownLanguages: {
    langList: { langCode: string; langValue: string }[];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  handleAgree: () => void = () => null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.articleId = props.match.params.id;
      if (props.type === 'news') {
        this.pageTitle = translate('editArticlePageTitle', {
        });
      } else {
        this.pageTitle = translate('academiesAnnouncementsTabEditAnnouncement', {
        });
      }
    } else {
      this.isNew = true;
      if (props.type === 'news') {
        this.pageTitle = translate('addArticlePageTitle', {
        });
      } else {
        this.pageTitle = translate('academiesAnnouncementsTabAddAnnouncement', {
        });
      }
    }
    this.initArticleSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    if (props.type === 'news') {
      this.articleFormTitle = translate('addArticlePageFormTitle', {
      });
    } else {
      this.articleFormTitle = translate('addAnnouncementPageFormTitle', {
      });
    }
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  updatePreviewCard = () => {
    const article = this.props.newsAndAnnouncementStore.selectedArticle;
    this.setState({
      title : article.title,
      description: draftToHtml(article.description).replace(/\n/g, '<br>'),
      startDate: article.startDate,
      image: article.image.length > 0
        ? article.image[0].imageUrl : '',
      images: (article.images.length
        ? article.images.map((image: any, index: number) => ({
          preview: image.imageUrl,
        })) : []),
      video: (article.video.length ? [{
        preview:  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7mqlAlw416LNquaSAtkJG-Ace7tW8I_cjD8_KPI5DDWGZRyVt",
      }] : []),
    });
    this.props.newsCategoryStore.categoriesList.forEach((item) => {
      if (item.categoryId === article.articleCategory) {
        this.setState({
          articleCategory: item.title,
        });
      }
    });
  }

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.setState({
        loadingManagedCountries: false,
      });
      this.forceUpdate();
      this.getArticleCategories(this.state.selectedLang);
      if (!this.isNew) {
        this.props.newsAndAnnouncementStore.getArticleById(this.articleId, 'news', languageCodes.english)
          .then(() => {
            this.updatePreviewCard();
            this.updateStateWithArticleData();
          }).catch(() => {
            this.setState({
              loadingArticle: false,
            });
          });
      }
    }
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  handelLanguageChange = (langCode: string) => {
      if (this.isNew) {
        this.setState({
          selectedLang: langCode,
        });
      } else {
        this.getArticle(langCode);
        this.getArticleCategories(langCode);
      }
  };

  initArticleSchema = () => {
    this.articleSchema = Yup.object().shape({
      title: Yup.string()
        .required('Required'),
      preview: Yup.string()
        .required('Required'),
      description: Yup.string()
        .required('Required'),
      articleCategory: Yup.number()
        .required('Required'),
      video: Yup.array(),
      images: Yup.array(),
      image: Yup.array()
        .when('video', {
          is: (video) => video.length === 1,
          then: Yup.array()
            .required('Thumbnail required'),
        }),
      startDate: Yup.date().typeError('Invalid date').required('Required'),
      endDate: Yup.date().nullable(true),
      isActive: Yup.boolean().default(true),
    });
  };

  getFormFields = (): FormField[] => {
    console.log('isEgypt', this.isEgypt);

    return [
      {
        name: 'title',
        label: this.isNew && this.isEgypt ? translate('addArticlePageFormArticleArabicTitle', {
        }) : translate('addArticlePageFormArticleTitle', {
        }),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'preview',
        label: this.isNew && this.isEgypt ? translate('addArticlePageFormArabicPreview', {
        }) : translate('addArticlePageFormPreview', {
        }),
        type: 'text',
        multiLine: true,
        rowsMax: 3,
        filedType: 'InputField',
      },
      {
        name: 'description',
        label: this.isNew && this.isEgypt ? translate('addArticlePageFormArabicDescription', {
        }) : translate('addArticlePageFormDescription', {
        }),
        filedType: 'RichTextField',
      },
      {
        name: 'articleCategory',
        label: translate('addArticlePageFormCategory', {
        }),
        selectList: [],
        selectListValue: 'title',
        selectListKey: 'categoryId',
        filedType: 'DropdownField',
      },
      {
        name: 'video',
        label: translate('addArticlePageFormVideo', {
        }),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'video/*',
        textMessage: translate('addVideoTextMessage', {
        }),
      },
      {
        name: 'image',
        label: translate('addArticlePageFormImage', {
        }),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        warningMessage: translate('addArticlePageFormWarningImageMessage', {
        }),
        size: 200,
      },
      {
        name: 'images',
        label: translate('addAcademyPageFormGallery', {
        }),
        filedType: 'GalleryField',
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'isActive',
        label: translate('addArticlePageFormStatus', {
        }),
        filedType: 'ToggleButtonField',
        activeLabel: translate('addArticlePageFormStatusPublishedLabel', {
        }),
        inactiveLabel: translate('addArticlePageFormStatusUnpublishedLabel', {
        }),
        value: true,
      },
      {
        name: 'startDate',
        label: translate('addArticlePageFormStartDate', {
        }),
        filedType: 'DatePickerField',
        minDate: this.isNew ? new Date() : undefined,
      },
      {
        name: 'endDate',
        label: translate('addArticlePageFormEndDate', {
        }),
        filedType: 'DatePickerField',
        minDate: this.isNew ? new Date() : undefined,
      },
    ];
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      open: false,
      processing: false,
      loadingArticle: !this.isNew,
      loadingCategories: true,
      loadingManagedCountries: true,
      selectedLang: languageCodes.english,
      categories: [],
      formFields: this.getFormFields(),
      title: '',
      description: null,
      articleCategory: '',
      startDate: null,
      image: '',
      images: [],
      video: [],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handleSubmit = async (values: any) => {
    const {
      countryStore, newsAndAnnouncementStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);
    this.setState({
      processing: true,
    });
    
    // check for start and end date condition first
    if (values.startDate && values.endDate) {
      if ( values.startDate > values.endDate) {

        this.setState({
          processing: false,
        });

        SnackBarComponent.getInstance().openSnackbar(
          'Start Date can\'t be greater than endDate',
          5000,
          'error'
        );
        return;
      }
    }

    if (this.isNew) {
      try {
        const articleId = await newsAndAnnouncementStore.createArticle(values, this.props.type);

        if (this.isEgypt) {
          this.props.history.replace(`${articleId}/edit`);
        } else {
          this.props.history.goBack();
        }

        SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
        }), 5000, 'success');

      } catch (error) {

        this.setState({
          processing: false,
        });

        SnackBarComponent.getInstance().openSnackbar(
          translate('errorMessage', {}),
          5000,
          'error');
      }
    } else if (values.startDate === values.endDate && newsAndAnnouncementStore.selectedArticle.isFeatured === true
        || values.isActive === false) {
      this.handleAgree = () => {
        this.props.newsAndAnnouncementStore.updateArticle(values, this.articleId, this.props.type, this.initGallery, this.state.selectedLang)
          .then(() => {
            this.setState({
              processing: false,
            });
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 5000, 'success');
            this.props.history.goBack();
          })
          .catch(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 5000, 'error');
            this.setState({
              processing: false,
            });
          });
        this.setState({
          open: false,
        });
      };
      this.handleClickOpen();
    } else {
      this.props.newsAndAnnouncementStore.updateArticle(values, this.articleId, this.props.type, this.initGallery, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 5000, 'success');
          this.props.history.goBack();
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    }
  };

  handleCancel = (): void => {
    console.log('canceled');
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handleCancel,
  });

  updateStateWithArticleData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: this.props.newsAndAnnouncementStore.selectedArticle[field.name],
      });
    }
    this.initGallery = Object.assign([], this.props.newsAndAnnouncementStore.selectedArticle.images);
    this.setState({
      formFields: formFieldsWithData, loadingArticle: false,
    });
  };

  updateStateWithCategoriesData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      if (field.name === 'articleCategory') {
        formFieldsWithData.push(
          {
            ...field, selectList: this.props.newsCategoryStore.categoriesList,
          },
        );
      } else {
        formFieldsWithData.push(field);
      }
    }
    this.setState({
      formFields: formFieldsWithData, loadingCategories: false,
    });
  };

  onChangeValues = (key: any, value: any) => {
    console.log(key, value);
    if (key === 'title') {
      this.setState({
        title: value,
      });
    }
    if (key === 'articleCategory') {
      this.props.newsCategoryStore.categoriesList.forEach((item) => {
        if (item.categoryId === value) {
          this.setState({
            articleCategory: item.title,
          });
        }
      })
    }
    if (key === 'description') {
      this.setState({
        description: draftToHtml(convertToRaw(value.getCurrentContent())).replace(/\n/g, '<br>'),
      });
    }
    if (key === 'startDate') {
      console.log(value, value.ts);
      this.setState({
        startDate: value.ts
      });
    }
    if (key === 'image') {
      this.setState({
        image: value.length > 0 ? value[0].preview : '',
      });
    }
    if (key === 'images') {
      this.setState({
        images: value,
      });
    }
    if (key === 'video') {
      const gallery = [{
        preview: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7mqlAlw416LNquaSAtkJG-Ace7tW8I_cjD8_KPI5DDWGZRyVt"
      }];
      this.setState({
        video: gallery,
      })
    }
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false, processing: false,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.screenContainer}>
        <div className={classes.formContainer}>
        <div className={classes.content}>
          {
            this.state.loadingArticle || this.state.loadingCategories || this.state.loadingManagedCountries
              ? <Spinner />
              : (
                <GeneralFormComponent
                  dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                  formTitle={this.articleFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.articleSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                  onChangeValues={(key: any, value: any) => this.onChangeValues(key, value)}
                />
              )
          }
          <AlertDialog
            title={translate(`${this.props.type}ListPageTitle`, {
            })}
            content={translate('newsListListDeactivationWarning', {
            })}
            isOpen={this.state.open}
            agree={this.handleAgree}
            disAgree={this.handleClose}
            hasActions
          />
        </div>
        </div>
        <div className={classes.previewCard}>
              <img className={classes.image} src={this.state.video.length ? this.state.video[0].preview : this.state.image ? this.state.image : images.placeHolder} />
            {
              !this.state.video.length &&
              (
                <div className={classes.gallery}>
                  <img className={classes.galleryImage} src={this.state.image ? this.state.image : images.placeHolder} />
                  {
                    this.state.images.map((image: any) => {
                      return <img className={classes.galleryImage} src={image.preview ? image.preview : image.imageUrl || images.placeHolder} />;
                    })
                  }
                </div>
              )
            }
          <p className={classes.articleTitle}>{this.state.title}</p>
          <div className={classes.categoryTitleContainer}>
            <p className={classes.categoryTitle} >{this.state.articleCategory}</p>
            <p className={classes.articleDate}>
              {
                this.state.startDate &&
                moment(Number(this.state.startDate)).format('DD/MM/YY')
              }
            </p>
          </div>
          <div className={classes.description}>
            {
              this.state.description
              ? parse(this.state.description,{})
              : null
            }
          </div>
        </div>
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
    } = this.props;

    await countryStore.getUserManagedCountries();
    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    this.initState(false);
    this.submitButton = this.getSubmitButton();
    this.setState({
      loadingManagedCountries: false,
    });
    this.getArticleCategories(this.isEgypt ? languageCodes.arabic : languageCodes.english);
    if (!this.isNew) {
      this.props.newsAndAnnouncementStore.getArticleById(this.articleId, 'news', languageCodes.english)
        .then(() => {
          this.updatePreviewCard();
          this.updateStateWithArticleData();
          if (this.props.history.location.from) {
            this.lastHistory = -2;
          }
        }).catch(() => {
          this.setState({
            loadingArticle: false,
          });
        });
    }
    // await this.props.countryStore.getUserManagedCountries();
  }

  getArticle = (langCode: string) => {
    this.setState({
      loadingArticle: true,
    });
    this.props.newsAndAnnouncementStore.getArticleById(this.articleId, this.props.type, langCode)
      .then(() => {
        this.updatePreviewCard();
        this.updateStateWithArticleData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loadingArticle: false,
        });
      });
  };

  getArticleCategories = (langCode: string) => {
    this.setState({
      loadingCategories: true,
    });
    this.props.newsCategoryStore.getArticlesCategories(this.props.countryStore.managedCountries, langCode)
      .then(() => {
        this.updateStateWithCategoriesData();
      }).catch(() => {
        this.setState({
          loadingCategories: false,
        });
      });
  };
}

export default withRouter(AddEditArticle);
